import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { clearTypeahed, fetchTypeaheadProductsByVMTitle } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class VMTitleTypeahead extends Component {
    static propTypes = {
        fetchTypeaheadProductsByVMTitle: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func,
        suggestions: PropTypes.array
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    handleSuggestionsFetchRequested = term => {
        this.props.fetchTypeaheadProductsByVMTitle(VMTitleTypeahead.name, { term });
    };

    render() {
        const options = this.props.suggestions.map(vm => ({
            label: vm.name,
            value: vm.id
        }));
        return (
            <MultiTypeahead
                options={options}
                isMulti
                value={this.props.value}
                titleId="vmTitle"
                animatedPlaceholder
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onChangeSuggestion={this.props.onChangeSuggestion}
                formatOptionLabel={this.props.renderMultiSuggestion}
                error={this.props.error}
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions: typeahead.source === VMTitleTypeahead.name ? typeahead.list : VMTitleTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchTypeaheadProductsByVMTitle,
    clearTypeahed
})(VMTitleTypeahead);
